import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function usersubscriptionDataReducer(
  state = initialState.usersubscribed,
  action
) {
  switch (action.type) {
    case types.USER_SUBSCRIPTION_DATA_SUCCESS:
      return action.usersubscriptionData;
    default:
      return state;
  }
}
